import { Box, makeStyles, Slider } from '@material-ui/core';
import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { editBgImageBlur } from 'src/store/modules/imageUpload';

interface blurProps {
  menuTitle: string;
  type: string;
  max: number;
}

const useStyles = makeStyles(() => ({
  root: {
    margin: '16px 16px 0px 16px'
  },
  input: {
    width: '2rem',
    height: '1.5rem',
    border: '1px solid #D9D9D9',
    textAlign: 'center',
    borderRadius: 4,
    outline: 0,
    padding: 0,
    marginLeft: 16,
    paddingBottom: 0,
    fontSize: 13
  }
}));

const EditBgDimmed: FC<blurProps> = ({ menuTitle, type, max }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const bgOpacity = useSelector(
    (state: RootState) => state.imageUpload.bgImageBlur
  );

  const handleBgDimmed = (event: any, newValue: number | number[]) => {
    const newBgOpacity = { [type]: newValue };
    dispatch(editBgImageBlur({ ...bgOpacity, ...newBgOpacity }));
  };

  const handleInputBgDimmed = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = Number(event.target.value.replace(/[^0-9.]/g, ''));
    if (newValue < 0 || newValue > max) {
      return;
    }
    const newBgOpacity = {
      [type]: newValue
    };
    return dispatch(editBgImageBlur({ ...bgOpacity, ...newBgOpacity }));
  };

  const handleBgDimmedRange = () => {
    if (bgOpacity[type] < 0) {
      const newMinOpacity = { [type]: 1 };
      dispatch(editBgImageBlur({ ...bgOpacity, ...newMinOpacity }));
    } else if (bgOpacity[type] > max) {
      const newMaxOpacity = { [type]: max };
      dispatch(editBgImageBlur({ ...bgOpacity, ...newMaxOpacity }));
    }
  };

  return (
    <div className={classes.root}>
      <div
        style={{
          fontFamily: 'Archivo',
          fontWeight: 600,
          fontSize: 14,
          letterSpacing: '0.02em'
        }}
      >
        {menuTitle}
      </div>
      <Box
        style={{
          display: 'flex',
          flexDirection: 'row',
          marginTop: 24,
          marginLeft: 6
        }}
      >
        <Slider
          value={typeof bgOpacity[type] === 'number' ? bgOpacity[type] : 0}
          aria-labelledby="input-slider"
          onChange={handleBgDimmed}
          step={1}
          max={max}
          min={1}
        />
        <input
          className={classes.input}
          type="text"
          value={bgOpacity && bgOpacity[type] ? bgOpacity[type] : ''}
          onChange={handleInputBgDimmed}
          onBlur={handleBgDimmedRange}
        />
      </Box>
    </div>
  );
};
export default EditBgDimmed;
